import { connect } from 'react-redux'

import {
  setData,
} from 'reduxpath/ducks/Sidebar'

import Sidebar from './units'

const mapStateToProps = state => ({
  sidebarData: state.Sidebar.data,
})

const mapDispatchToProps = dispatch => ({
  handleSidebar(data) {
    const params = {
      opened: !data.opened,
      bodyClass: data.opened
        ? 'page-header-fixed page-sidebar-closed-hide-logo page-content-white'
        : 'page-header-fixed page-sidebar-closed-hide-logo page-content-white page-sidebar-closed',
      ulClass: data.opened
        ? 'page-sidebar-menu page-header-fixed'
        : 'page-sidebar-menu page-header-fixed page-sidebar-menu-closed',
    }
    dispatch(setData(params))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar)
